module.exports = __webpack_public_path__ + "img/title.099e72ce.png";